import React, { Component, useState } from "react";
// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../../widgets/tables/Table";
import WaitDialog from "../../../widgets/WaitDialog";

import SendMailWidget from "../../../widgets/SendMailWidget";
import SendNotificationWidget from "../../../widgets/SendNotificationWidget";
import GetInsegnanti from "../../../services/getInsegnanti";
import Utils from "../../../utils/utils";
import SelectPdfDatesWidget from "../../../widgets/SelectPdfDatesWidget";
import FusioneWidget from "../../../widgets/FusioneWidget";
import addGruppoInsegnanti from "../../../services/addGruppoInsegnanti";
import getGruppiInsegnanti from "../../../services/getGruppiInsegnanti";
import addNotification from "../../../services/addNotification";
import sendMail from "../../../services/sendMail";
import getSetting from "../../../services/getSetting";
import saveFile from "../../../services/saveFile";
import addUtente from "../../../services/addUtente";
import Constants from "../../../utils/consts";
import WaitDialogFileDownload from "../../../widgets/WaitDialogFileDownload";

export default class Corsi extends React.Component {
	constructor(props) {
		super(props);

		this.pageDiv = {
			border: "1px solid #cccccc",
			padding: 10,
		};

		this.pageTitle = props.pageTitle;
		this.pageName = props.pageName;
		if (this.pageName == undefined) {
			this.pageName = this.section;
		}

		this.options = [{ value: "All", label: "All" }];

		this.selectRef = React.createRef();

		this.state = {
			testo: "",
			menuBackground: "#ffffff",
			menuItemColor: "#000000",
			fontSize: 50,
			fontBold: false,
			logoPicture: "",
			logoMargin: 0,
			titleColor: "#000000",
			titleSize: 18,
			isLoading: false,
			addElementVisible: false,
			waitDialogVisible: false,
			selectPdfDatesVisible: false,
			fusioneEnabled: false,
			insegnanti: [],
			gruppiInsegnantiComplete: [],
			mailCompaniesList: [],
			reportPeriod: "",
			waitDialogFileVisible: false,
			fileReady: false,
		};

		this.grid = 2;
		this.tableRef = React.createRef();

		this.pdfElements = [];

		this.insegnanti = [];
		this.gruppiInsegnantiComplete = [];
		this.pageTitle = "Insegnanti";
		this.brokerId = undefined;

		const cookies = new Cookies();
		var strJson = JSON.stringify({ list: [] });
		cookies.set("checksList", strJson, { path: "/" });
		this.sendMailRef = React.createRef();
		this.sendNotificationRef = React.createRef();

		this.state = {};
	}

	async reload() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });

		this.insegnanti = await GetInsegnanti(username, token);
		this.gruppiInsegnanti = await getGruppiInsegnanti(username, token);

		this.gruppiInsegnantiComplete = [];
		this.gruppiInsegnanti.forEach(i => {
			var splitted = i.insegnanti.split("---");
			var nomi = "";
			splitted.forEach(s => {
				if (s != "") {
					var val = this.insegnanti.find(i => i.id == s);
					if (val != undefined) {
						if (nomi.length > 1) nomi += ", ";
						nomi += val.cognome + " " + val.nome;
					}
				}
			});
			i._insegnanti = nomi;
			this.gruppiInsegnantiComplete.push(i);
		});

		this.setState({
			insegnanti: this.insegnanti,
			fusioneEnabled: false,
			gruppiInsegnantiComplete: this.gruppiInsegnantiComplete,
		});
	}

	async componentDidMount() {
		await this.reload();
	}

	render() {
		var headCells = [
			{ id: "cognome", numeric: false, disablePadding: true, label: "Cognome" },
			{ id: "nome", numeric: false, disablePadding: true, label: "Nome" },
			{ id: "mail", numeric: true, disablePadding: false, label: "Mail" },
			{ id: "_", numeric: true, disablePadding: false, label: "" },
		];

		this.searchCols = ["nome", "cognome", "materie", "mail"];
		this.searchColsGroups = ["nome", "insegnanti"];

		const cookies = new Cookies();

		this.tableRef.current && this.tableRef.current.clearSearch();

		if (!this.state.gruppiInsegnantiComplete) return <div />;

		return (
			<div id={Math.random()}>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle title={this.pageTitle} />

					<Table
						searchValue={""}
						id={Math.random()}
						headCells={headCells}
						searchCols={this.searchCols}
						rows={this.state.insegnanti}
						onEventClick={row => {
							cookies.set("currentInsegnante", row, { path: "/" });
							window.location.href = "/#/billing/fattureInsegnante";
						}}
					/>

					{this.elementPdf ? this.elementPdf : null}
					<SendMailWidget
						ref={this.sendMailRef}
						show={this.state.sendMailVisible}
						onClose={() => this.setState({ sendMailVisible: false })}
						onSend={async (subject, body, file) => {
							const cookies = new Cookies();
							const username = cookies.get("username", { path: "/" });
							const token = cookies.get("token", { path: "/" });
							this.mail = await getSetting(username, token, "sendingMailAddress");
							this.mailPassword = await getSetting(username, token, "sendingMailPassword");

							//            this.state.sendMailUserId
							var insegnantiMail = this.insegnanti.filter(
								s => this.state.sendMailUserId.indexOf(s.id) != -1
							);

							if (file != undefined) {
								this.filePath = await saveFile(username, token, file.name, file.base64);
							}

							insegnantiMail.forEach(async insegnante => {
								insegnante.mail = insegnante.mail.trim();
								insegnante.mail2 = insegnante.mail2.trim();

								if (insegnante.mail != "" && Utils.validateEmail(insegnante.mail) == false) {
									alert("L'indirizzo " + insegnante.mail + " non è valido");
									return;
								}
								if (insegnante.mail2 != "" && Utils.validateEmail(insegnante.mail2) == false) {
									alert("L'indirizzo " + insegnante.mail2 + " non è valido");
									return;
								}

								if (insegnante.mail != "")
									await sendMail(
										username,
										token,
										this.mail,
										"Accademia Nazionale del Cinema",
										this.mailPassword,
										insegnante.mail,
										insegnante.nome + " " + insegnante.cognome,
										file ? this.filePath.name : "",
										subject,
										body
									);
								if (insegnante.mail2 != "")
									await sendMail(
										username,
										token,
										this.mail,
										"Accademia Nazionale del Cinema",
										this.mailPassword,
										insegnante.mail2,
										insegnante.nome + " " + insegnante.cognome,
										file ? this.filePath.name : "",
										subject,
										body
									);
							});

							this.setState({ waitDialogVisible: false });
							this.setState({ sendMailVisible: false });
						}}
					/>

					<SendNotificationWidget
						ref={this.sendNotificationRef}
						show={this.state.sendNotificationVisible}
						onClose={() => this.setState({ sendNotificationVisible: false })}
						onSend={async (subject, body, bodyFull) => {
							const cookies = new Cookies();
							const username = cookies.get("username", { path: "/" });
							const token = cookies.get("token", { path: "/" });

							this.state.notificationUser.forEach(async insegnante => {
								await addNotification(
									username,
									token,
									"INSEGNANTE",
									insegnante,
									subject,
									body,
									bodyFull,
									0
								);
							});

							this.setState({ waitDialogVisible: false });
							this.setState({ sendNotificationVisible: false });
						}}
					/>

					<SelectPdfDatesWidget
						show={this.state.selectPdfDatesVisible}
						key={Math.random()}
						onCancel={() => this.setState({ selectPdfDatesVisible: false })}
						onOkClicked={(dateFrom, dateTo) => {
							const cookies = new Cookies();
							cookies.set(
								"currentInsegnante",
								this.state.pdfElem ? this.state.pdfElem : this.state.pdfGroupElem,
								{ path: "/" }
							);
							cookies.set("dateFrom", dateFrom, { path: "/" });
							cookies.set("dateTo", dateTo, { path: "/" });
							window.location.href = this.state.pdfElem
								? "#/app/pdfInsegnantiPage"
								: "#/app/pdfInsegnantiGroupPage";
						}}
					/>

					<FusioneWidget
						show={this.state.fusioneEnabled}
						key={Math.random()}
						onCancel={() => this.setState({ fusioneEnabled: false })}
						onOkClicked={async (nome, listInsegnanti) => {
							const cookies = new Cookies();
							const username = cookies.get("username", { path: "/" });
							const token = cookies.get("token", { path: "/" });

							var insegnanti = "";
							listInsegnanti.forEach(i => {
								insegnanti += i.value + "---";
							});
							var ret = await addGruppoInsegnanti(username, token, nome, insegnanti);

							var newUsername = await Utils.generateUsername(username, token, nome, "");
							var password = Utils.generatePassword();
							await addUtente(username, token, "", "", newUsername, password, 3, ret.id);

							this.setState({ fusioneEnabled: false });
							this.reload();
						}}
					/>

					<WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index} />
					<WaitDialogFileDownload
						onClose={() => this.setState({ waitDialogFileVisible: false })}
						show={this.state.waitDialogFileVisible}
						ready={this.state.fileReady}
						file={"https://" + Constants.mainUrl + "pdf/fatturazione.xlsx"}
						key={Math.random()}
						index={this.state.index}
					/>
				</LoadingOverlay>
			</div>
		);
	}
}
